export default __webpack_public_path__ + "img/BB_RTK_250MA_BF.58781066477c33c93f396bc1836b29c8.jpg";